"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var Radio =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Radio, _Component);

  function Radio() {
    var _getPrototypeOf2, _context;

    var _this;

    (0, _classCallCheck2.default)(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Radio)).call.apply(_getPrototypeOf2, (0, _concat.default)(_context = [this]).call(_context, args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onInvalid", function (evt) {
      evt.preventDefault();
      var onValidationChange = _this.props.onValidationChange;

      if (onValidationChange) {
        onValidationChange(evt.currentTarget.validity);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onChange", function (evt) {
      var _this$props = _this.props,
          onValidationChange = _this$props.onValidationChange,
          onChange = _this$props.onChange;

      if (onValidationChange) {
        onValidationChange();
      }

      if (onChange) {
        onChange(evt);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Radio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._input.addEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._input.removeEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          label = _this$props2.label,
          className = _this$props2.className,
          name = _this$props2.name,
          value = _this$props2.value,
          defaultChecked = _this$props2.defaultChecked,
          disabled = _this$props2.disabled,
          required = _this$props2.required,
          id = _this$props2.id;
      var classes = (0, _classnames.default)('Radio', 'FormElement', className);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement("input", {
        ref: function ref(node) {
          _this2._input = node;
        },
        className: "FormElement-item",
        id: "Radio-".concat(id),
        type: "radio",
        name: name,
        value: value,
        defaultChecked: defaultChecked,
        onChange: this._onChange,
        disabled: disabled,
        required: required
      }), (0, _react.cloneElement)(label, {
        htmlFor: "Radio-".concat(id)
      }));
    }
  }]);
  return Radio;
}(_react.Component);

exports.default = Radio;